// extracted by mini-css-extract-plugin
export var content = "Hero-module--content--be67e";
export var core = "Hero-module--core--814b8";
export var form = "Hero-module--form--97087";
export var formCore = "Hero-module--form-core--7743e";
export var textSwitch = "Hero-module--text-switch--7a630";